import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import {
  hasDisplayableLabPromotionalPrice,
  type LabPromotionalPriceDisplay,
} from "@shared/utils/hasDisplayableLabPromotionalPrice/hasDisplayableLabPromotionalPrice";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./JourneyCheckoutPrice.styles";

interface Props {
  price: number;
  promotionalPrice?: LabPromotionalPriceDisplay | null;
}

const formatPrice = (amount: number) => `$${amount.toFixed(2)}`;

const JourneyCheckoutPrice = ({ price, promotionalPrice }: Props) => {
  const { t } = useTranslation();

  return (
    <span css={styles.priceGroup}>
      {hasDisplayableLabPromotionalPrice(promotionalPrice) ? (
        <>
          <Typography as="span" isStrikethrough colorIntensity="subtle" aria-hidden>
            {formatPrice(promotionalPrice.originalPrice)}
          </Typography>
          <span css={styles.visuallyHidden}>
            {t(l.journeyCheckout.orderSummary.originalPriceLabel, {
              price: formatPrice(promotionalPrice.originalPrice),
            })}
          </span>
        </>
      ) : null}
      <Typography as="span">{formatPrice(price)}</Typography>
    </span>
  );
};

export { JourneyCheckoutPrice };
